module.exports = "<style>#tplindicator_refer .ztree{overflow:hidden}</style> <div id=tplindicator_refer> <div class=u-row> <div class=u-col-12> <u-grid params=\"config: gridconfig\"></u-grid> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/modalrefer/feedbacktype/index.html
// module id = 271
// module chunks = 144